
import { get, post, put, del } from '../../src/services/api';

const BASE = '/produits';

export const fetchProduits = async () => {
  const res = await get(BASE);
  return res.data;
};

export const ajouterProduit = async (formData) => {
  const res = await post(BASE, formData);
  return res.data;
};

export const modifierProduit = async (id, formData) => {
  const res = await put(`${BASE}/${id}`, formData);
  return res.data;
};

export const supprimerProduit = async (id) => {
  const res = await del(`${BASE}/${id}`);
  return res.data;
};

// Liste Users pour admin (si tu l’utilises vraiment ici)
export const fetchUsers = async () => {
  const res = await get('/clients');
  return res.data.map(c => ({
    id: c.id,
    nom: c.nom,
    prenom: c.prenom,
    email: c.email,
    telephone: c.telephone,
    adresse: c.adresse,
    created_at: c.created_at ?? null,
    fullName: [c.nom, c.prenom].filter(Boolean).join(' ')
  }));
};
